import { PARTNER_PAGE_TEMPLATE_QUERY } from '@ecomm/partners-data'
import { useContentful } from '@ecomm/shared-apollo'

export const usePartnerPageTemplateQuery = (id: string) => {
  const { data } = useContentful(PARTNER_PAGE_TEMPLATE_QUERY, { id })
  return data
}
